/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import useControlled from '../hooks/useControlled.js';
import '../_chunks/dep-2acfafca.js';
import 'react';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/noop.js';

function useControllable(props) {
  var _useControlled = useControlled(props, "value", props.onChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    onChange = _useControlled2[1];
  var _useControlled3 = useControlled(props, "expanded", props.onExpand),
    _useControlled4 = _slicedToArray(_useControlled3, 2),
    expanded = _useControlled4[0],
    onExpand = _useControlled4[1];
  var _useControlled5 = useControlled(props, "actived", props.onActive),
    _useControlled6 = _slicedToArray(_useControlled5, 2),
    actived = _useControlled6[0],
    onActive = _useControlled6[1];
  return {
    value: value,
    onChange: onChange,
    expanded: expanded,
    onExpand: onExpand,
    actived: actived,
    onActive: onActive
  };
}

export { useControllable as default };
//# sourceMappingURL=useControllable.js.map
